export {
    PrimaryMailFolderHierarchyDocument,
    PrimaryMailFolderHierarchyQuery,
    PrimaryMailFolderHierarchyQueryVariables,
} from './components/__generated__/PrimaryMailFolderHierarchyQuery.interface';
export { default as MailFolderTreesParentContainer } from './components/MailFolderTreesParentContainer';
export { toggleFolderTreeCollapsed } from './operations/toggleFolderTreeCollapsed';
